const lastMessageThreadCache = new Map();
const FALLBACK_LAST_THREAD_STORAGE_KEY = "afrimed:messages:last-thread";

function getLastMessageThreadStorageKey(currentUserId) {
  const scopedUserId = String(currentUserId || "guest").trim() || "guest";
  return `afrimed:messages:last-thread:${scopedUserId}`;
}

function normalizeThreadPath(value) {
  const path = String(value || "").trim();
  return path.startsWith("/messages/") ? path : "";
}

export function readLastMessageThreadPath(currentUserId) {
  if (typeof window === "undefined") return "";

  const storageKey = getLastMessageThreadStorageKey(currentUserId);
  const cachedPath = normalizeThreadPath(lastMessageThreadCache.get(storageKey));
  if (cachedPath) return cachedPath;

  const fallbackCachedPath = normalizeThreadPath(
    lastMessageThreadCache.get(FALLBACK_LAST_THREAD_STORAGE_KEY)
  );
  if (fallbackCachedPath) return fallbackCachedPath;

  try {
    return (
      normalizeThreadPath(window.sessionStorage?.getItem(storageKey)) ||
      normalizeThreadPath(window.sessionStorage?.getItem(FALLBACK_LAST_THREAD_STORAGE_KEY))
    );
  } catch {
    return cachedPath || fallbackCachedPath;
  }
}

export function writeLastMessageThreadPath(currentUserId, path) {
  if (typeof window === "undefined") return;

  const storageKey = getLastMessageThreadStorageKey(currentUserId);
  const normalizedPath = normalizeThreadPath(path);

  if (!normalizedPath) return;

  lastMessageThreadCache.set(storageKey, normalizedPath);
  lastMessageThreadCache.set(FALLBACK_LAST_THREAD_STORAGE_KEY, normalizedPath);

  try {
    window.sessionStorage?.setItem(storageKey, normalizedPath);
    window.sessionStorage?.setItem(FALLBACK_LAST_THREAD_STORAGE_KEY, normalizedPath);
  } catch {}
}

export function clearLastMessageThreadPath(currentUserId) {
  if (typeof window === "undefined") return;

  const storageKey = getLastMessageThreadStorageKey(currentUserId);
  lastMessageThreadCache.delete(storageKey);
  lastMessageThreadCache.delete(FALLBACK_LAST_THREAD_STORAGE_KEY);

  try {
    window.sessionStorage?.removeItem(storageKey);
    window.sessionStorage?.removeItem(FALLBACK_LAST_THREAD_STORAGE_KEY);
  } catch {}
}

export function resolveMessagesTabTarget(currentUserId, pathname = "") {
  const currentPath = normalizeThreadPath(pathname);
  if (currentPath) return currentPath;

  return readLastMessageThreadPath(currentUserId) || "/messages";
}
